import React from 'react'
import { object, string } from 'prop-types'

// components
import DailyFunnelChart from './DailyFunnels/DailyFunnelChart'
import DailyFunnelChartWithLinks from './DailyFunnels/DailyFunnelChartWithLinks'
import DailyFunnelChartWithClicks from './DailyFunnels/DailyFunnelChartWithClicks'

const DailyFunnelLoader = (props) => {
  let { dailyFunnelType } = props
  let customFunnel
  if (dailyFunnelType === 'regular') {
    customFunnel = <DailyFunnelChart {...props} />
  } else if (dailyFunnelType === 'regular-with-links') {
    customFunnel = <DailyFunnelChartWithLinks {...props} />
  } else if (dailyFunnelType === 'regular-with-clicks') {
    customFunnel = <DailyFunnelChartWithClicks {...props} />
  }
  return customFunnel
}

DailyFunnelLoader.propTypes = {
  timeframe: object,
  campaign: object,
  actor: string,
  video: object
}

export default DailyFunnelLoader



// WEBPACK FOOTER //
// ./src/components/charts/DailyFunnelLoader.js